import { useState } from 'react';
import '../../styles/FAQSection.css'; // FAQSection ki CSS
import { Link } from 'react-router-dom';

const faqData = [
  {
    id: 1,
    question: "What is VernaEvents and how does it work?",
    answer: "VernaEvents is India's premier sports event discovery and registration platform. It connects athletes, teams, and sports enthusiasts with upcoming tournaments and events. You can browse events by sport, register your team, and manage your bookings all in one place."
  },
  {
    id: 2,
    question: "How can I register my team for a sports event?",
    answer: "Registering your team is simple. Browse our upcoming events, click on 'Register Now' on your chosen event, fill in your team details including team name, captain information, and player list, then submit your registration. You'll receive a confirmation email with your booking details."
  },
  {
    id: 3,
    question: "What sports are available on VernaEvents?",
    answer: "We offer a wide range of sports including Cricket, Football, Basketball, Volleyball, Tennis, and Badminton. We're constantly adding new sports categories based on user demand and popular tournaments."
  },
  {
    id: 4,
    question: "Is there a registration fee for participating in events?",
    answer: "Registration fees vary by event. Each event listing clearly displays the registration fee. Some events may be free while others have a participation fee that covers tournament organization, prizes, and facilities."
  },
  {
    id: 5,
    question: "How do I know if my team is registered successfully?",
    answer: "After completing the registration process, you'll receive an immediate confirmation on screen with your booking ID. You'll also get a confirmation email with all your booking details for future reference."
  },
  {
    id: 6,
    question: "What happens if my event gets cancelled?",
    answer: "If an event is cancelled by the organizer, all registered teams will be notified via email and SMS. Full registration fees will be refunded to the original payment method within 5-7 business days."
  },
  {
    id: 7,
    question: "How many players can be in a team?",
    answer: "Team size varies by sport and tournament format. For example, Cricket tournaments typically allow 11 players with substitutes, Football has 7-player teams, and Volleyball has 4-6 players per team. Each event listing specifies the exact team composition requirements."
  },
  {
    id: 8,
    question: "Can I cancel my team's registration after booking?",
    answer: "Yes, you can cancel your registration by contacting our support team via email or phone. Please check the event's cancellation policy as some events may have specific deadlines and refund conditions."
  }
];

function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section-wrapper">
      {/* Animated Background */}
      <div className="faq-bg-glow faq-bg-glow-1"></div>
      <div className="faq-bg-glow faq-bg-glow-2"></div>

      <div className="faq-container">
        {/* Section Header */}
        <div className="faq-header-wrapper">
          <div className="faq-badge-wrapper">
            <span className="faq-badge-dot"></span>
            <span className="faq-section-badge">❓ FAQ</span>
          </div>
          <h2 className="faq-title">
            Frequently Asked <span className="faq-title-highlight">Questions</span>
          </h2>
          <p className="faq-subtitle">
            Find answers to the most common questions about VernaEvents, 
            team registration, and participating in sports events
          </p>
        </div>

        {/* FAQ Grid */}
        <div className="faq-grid-wrapper">
          {faqData.map((item, index) => (
            <div 
              key={item.id} 
              className={`faq-item-wrapper ${openIndex === index ? 'active' : ''}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question-wrapper">
                <span className="faq-question-icon">
                  {openIndex === index ? '−' : '+'}
                </span>
                <h3 className="faq-question">{item.question}</h3>
              </div>
              <div className={`faq-answer-wrapper ${openIndex === index ? 'open' : ''}`}>
                <p className="faq-answer">{item.answer}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="faq-bottom-cta">
          <div className="faq-bottom-content">
            <div className="faq-bottom-left">
              <span className="faq-bottom-icon">💬</span>
              <div>
                <h4>Still have questions?</h4>
                <p>We're here to help. Reach out to our support team anytime</p>
              </div>
            </div>
            <div className="faq-bottom-right">
              <a href="mailto:info@vernaevents.com" className="faq-contact-btn">
                Contact Support →
              </a>
              <Link to="/contact" className="faq-contact-btn-secondary">
                Contact Form
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FAQSection;